import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { SiteFooterLayout, SiteHeaderLayout, SiteHeaderProvider, SliceLayoutBoundary, SlicesRenderer } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
const cls = classNames('page-layout-Home');

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const LayoutStyles = breakpoints({
  base: css`
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `
});


// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(SlicesRenderer)`${LayoutStyles}`,
    Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const PageLayoutCommunity: PageLayoutComponent = (props) => {
  const { className, entity } = props;

  const { slices = [] } = entity;

  const ref = React.useRef<HTMLDivElement>(null);
  // console.log(ref);

  return (
    <SiteHeaderProvider
      value={{
        variant: 'default',
        boundary: 'feature-slim',
      }}>
      <My.Container className={cls.name(className)}>
        <My.Header ref={ref} />
        <My.Layout items={slices} />
        <My.Footer />
      </My.Container>
    </SiteHeaderProvider>
  )
};
